import { htmlDecode } from '@vue-storefront/core/filters/html-decode'

const DETAILS_RE = /<details\b[^>]*\bfaq-details\b[^>]*>([\s\S]*?)<\/details>/gi
const ENCODED_TAG_RE = /&lt;\s*(\/?)\s*([a-zA-Z][a-zA-Z0-9]*)\s*&gt;/g

/** Turn stored "&lt;strong&gt;" back into a real tag. Other entities stay escaped. */
export function unescapeEncodedTags (html) {
  return String(html == null ? '' : html).replace(ENCODED_TAG_RE, '<$1$2>')
}

function toText (html) {
  const stripped = unescapeEncodedTags(html)
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|tr|ul|ol)>/gi, '\n')
    .replace(/<[^>]+>/g, '')
  return htmlDecode(stripped)
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]*\n[ \t]*/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/[ \t]{2,}/g, ' ')
    .trim()
}

/**
 * FAQPage for CMS markup: details.faq-details > summary + answer.
 * Returns null when the page has no such questions.
 */
export function faqPageJsonLd (html) {
  if (!html || typeof html !== 'string' || !html.includes('faq-details')) return null

  const mainEntity = []
  const seen = new Set()

  for (const match of html.matchAll(DETAILS_RE)) {
    const block = match[1]
    const summaryMatch = block.match(/<summary\b[^>]*>([\s\S]*?)<\/summary>/i)
    if (!summaryMatch) continue
    const name = toText(summaryMatch[1]).replace(/\s+/g, ' ').trim()
    const text = toText(block.slice(summaryMatch.index + summaryMatch[0].length))
    if (!name || !text) continue
    const key = name.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    mainEntity.push({
      '@type': 'Question',
      name,
      acceptedAnswer: {
        '@type': 'Answer',
        text
      }
    })
  }

  if (!mainEntity.length) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity
  }
}
